"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.search.js");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _PagesHeader = _interopRequireDefault(require("@evdy/web-core/dist/components/PagesHeader2"));

var _PagesFooter = _interopRequireDefault(require("@evdy/web-core/dist/components/PagesFooter"));

var _PopupDialog = _interopRequireDefault(require("@evdy/web-core/dist/components/shared/elements/PopupDialog"));

var _LoaderComponent = _interopRequireDefault(require("@evdy/web-core/dist/components/shared/elements/LoaderComponent"));

var _Input = require("@evdy/web-core/dist/components/shared/Input");

var _user = require("@evdy/web-redux/dist/actions/dash/user");

require("@evdy/web-core/dist/sass/containers/RequestPassword.css");

var _dec, _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var model = 'forms.passwordReset';
var ResetPassword = (_dec = (0, _reactRedux.connect)(function (_ref) {
  var dash = _ref.dash,
      forms = _ref.forms;
  return {
    user: dash.user,
    password: forms.passwordReset.password,
    passwordConfirmMeta: forms.formsMeta.passwordReset.passwordConfirm
  };
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ResetPassword, _React$Component);

  var _super = _createSuper(ResetPassword);

  function ResetPassword(props) {
    var _this;

    _classCallCheck(this, ResetPassword);

    _this = _super.call(this, props);
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.resetError = _this.resetError.bind(_assertThisInitialized(_this));
    _this.errorDialog = _this.errorDialog.bind(_assertThisInitialized(_this));
    _this.successDialog = _this.successDialog.bind(_assertThisInitialized(_this));
    _this.revalidateConfirmPassword = _this.revalidateConfirmPassword.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ResetPassword, [{
    key: "handleSubmit",
    value: function handleSubmit(_ref2) {
      var password = _ref2.password;
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          location = _this$props.location;
      dispatch((0, _user.updatePassword)(password, location.query.s_token));
    }
  }, {
    key: "resetError",
    value: function resetError() {
      this.props.dispatch((0, _user.resetError)());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.dispatch((0, _user.resetMeta)());
    }
  }, {
    key: "errorDialog",
    value: function errorDialog(_ref3) {
      var message = _ref3.message,
          original = _ref3.original;
      return /*#__PURE__*/_react.default.createElement(_PopupDialog.default, {
        title: "Password Reset Problem",
        actions: [{
          label: 'Try Again',
          onClick: this.resetError,
          primary: true
        }],
        actAsExpander: !!original,
        showExpandableButton: !!original,
        stackTrace: original && original.stack
      }, message);
    }
  }, {
    key: "successDialog",
    value: function successDialog() {
      return /*#__PURE__*/_react.default.createElement(_PopupDialog.default, {
        title: "Password Reset Successfully",
        actions: [{
          label: 'Close',
          onClick: ResetPassword.redirectToLogin,
          primary: true
        }]
      }, "Your password has been successfully reset.");
    }
  }, {
    key: "revalidateConfirmPassword",
    value: function revalidateConfirmPassword(_ref4) {
      var password = _ref4.target.value;
      var _this$props2 = this.props,
          dispatch = _this$props2.dispatch,
          isTouched = _this$props2.passwordConfirmMeta.touched;

      if (isTouched) {
        dispatch(_Input.formActions.validate("".concat(model, ".passwordConfirm"), {
          mustMatch: function mustMatch(val) {
            return val === password;
          }
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          location = _this$props3.location,
          _this$props3$user = _this$props3.user,
          isFetching = _this$props3$user.isFetching,
          meta = _this$props3$user.meta,
          error = _this$props3$user.error,
          password = _this$props3.password,
          isValid = _this$props3.passwordConfirmMeta.valid;
      var currentPage = 'request-password';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "password-page-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_PagesHeader.default, {
        currentPage: currentPage,
        pathname: location.pathname,
        queryString: location.search
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "password-page-content"
      }, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement("h1", null, "Password Reset")), /*#__PURE__*/_react.default.createElement(_Input.Form, {
        model: model,
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement(_Input.InputGroup, {
        required: true,
        labelText: "Password",
        model: ".password",
        type: "password",
        onChange: this.revalidateConfirmPassword,
        validators: {
          isRequired: _Input.isRequired
        },
        messages: {
          isRequired: 'Please enter a new password'
        }
      }), /*#__PURE__*/_react.default.createElement(_Input.InputGroup, {
        required: true,
        labelText: "Password Confirmation",
        model: ".passwordConfirm",
        type: "password",
        validators: {
          isRequired: _Input.isRequired,
          mustMatch: function mustMatch(val) {
            return val === password;
          }
        },
        messages: {
          isRequired: 'Please re-enter password',
          mustMatch: 'Passwords must match'
        }
      }), /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        disabled: !isValid
      }, "Reset Password"))), /*#__PURE__*/_react.default.createElement(_PagesFooter.default, {
        currentPage: currentPage,
        pathname: location.pathname,
        queryString: location.search,
        showAuthLinks: false
      }), isFetching && /*#__PURE__*/_react.default.createElement(_LoaderComponent.default, {
        active: isFetching
      }), error && error.message && this.errorDialog(error), meta && meta.isReset && this.successDialog());
    }
  }], [{
    key: "redirectToLogin",
    value: function redirectToLogin() {
      _reactRouter.browserHistory.push('/dash/login');
    }
  }]);

  return ResetPassword;
}(_react.default.Component)) || _class);
var _default = ResetPassword;
exports.default = _default;